// This file is auto-generated by 'pnpm rebuild:icons'
import type { TemplateOnlyComponent } from '@ember/component/template-only';

import type { Signature } from './types.ts';

const IconComponent: TemplateOnlyComponent<Signature> = <template>
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    fill='none'
    viewBox='0 0 18 18'
    ...attributes
  ><path
      stroke='#000'
      stroke-linecap='round'
      stroke-linejoin='round'
      stroke-width='2'
      d='M5.64 7.398a.609.609 0 0 1-.543-.938l3.239-5.147a.61.61 0 0 1 1.041-.037l3.218 5.166a.61.61 0 0 1-.497.956zM6.569 10.916H2.222a.87.87 0 0 0-.87.87v4.346c0 .48.39.87.87.87h4.347c.48 0 .869-.39.869-.87v-4.347a.87.87 0 0 0-.87-.869M13.958 17.001a3.043 3.043 0 1 0 0-6.085 3.043 3.043 0 0 0 0 6.085'
    /></svg>
</template>;

// @ts-expect-error this is the only way to set a name on a Template Only Component currently
IconComponent.name = 'SelectAll';
export default IconComponent;
